export default __webpack_public_path__ + "static/988-863b46f8c2a7b0e72a5930490d232121.gif";